import React, { useState, useEffect } from 'react';
import Header from '../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../Components/Dashboard/Sidebar/Sidebar';
import './UserReport.css';
import { BiHomeAlt } from 'react-icons/bi';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { Apiurl, GetToken } from '../../../Utils/utils';
import axios from 'axios';

const UserReport = () => {
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [leaveData, setLeaveData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleSelect = (e) => {
    const userId = e.target.value;
    setSelectedEmployee(userId);

    if (userId) {
      GetUserLeaveReport(userId);
    } else {
      setLeaveData(null);
    }
  };

  const handleReset = () => {
    setSelectedEmployee('');
    setLeaveData(null);
  };

  const GetAllEmployee = () => {
    setLoading(true);
    const token = GetToken();

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setAllEmployeeData(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetAllEmployee();
  }, []);

  const GetUserLeaveReport = (userId) => {
    const token = GetToken();

    const option = {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Leave/GetUserLeaveReport`,
      data: {
        data: JSON.stringify({ UserId: userId }),
      },
    };

    axios(option)
      .then((res) => {
        if (res?.data?.success) {
          const parsedData = JSON.parse(res?.data?.data);
          setLeaveData(parsedData);
        }
      })
      .catch(() => {
        setLeaveData(null);
      });
  };

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-page"
                : "main-container-of-all-employees-page-new"
            }
          >
            <div className="inner-container-of-all-userreport-page">
              <div className="header-of-employees-page row">
                <div className="all-employee-text col">
                  <h4>User Report</h4>
                </div>
                <div className="all-employees-directory col">
                  <div className="home-icon-header">
                    <BiHomeAlt className="home-icon-header-inn" />
                  </div>
                  <div className="arrow-icon-header">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-header">
                    <p>Admin</p>
                  </div>
                  <div className="arrow-icon-header">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-header">
                    <p>User Report</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="body-part-outer-container">
              <div className="inner-body-container-of-userreport-table row-12">
                <div className="user-report-card">
                  <div className="user-report-card-header">
                    <h2>User Leave Report</h2>
                  </div>
                  <div className="user-report-card-controls">
                    <select
                      value={selectedEmployee}
                      onChange={handleSelect}
                      className="user-report-select"
                    >
                      <option value="">Select Employee</option>
                      {allEmployeeData.map((emp) => (
                        <option key={emp.UserId} value={emp.UserId}>
                          {emp.FirstName} {emp.LastName}
                        </option>
                      ))}
                    </select>
                    <button className="user-report-reset-btn" onClick={handleReset}>Reset</button>
                  </div>
                  {leaveData ? (
                    <div className="user-report-table-wrapper">
                      <table className="user-report-table">
                        <thead>
                          <tr>
                            <th>Three Quarter Leave</th>
                            <th>Short Leave</th>
                            <th>Half Day Leave</th>
                            <th>Casual Leave</th>
                            <th>Official Leave</th>
                            <th>Sick Leave</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{leaveData?.ThreeQuarterLeave ?? 0}</td>
                            <td>{leaveData?.ShortLeave ?? 0}</td>
                            <td>{leaveData?.HalfDayleave ?? 0}</td>
                            <td>{leaveData?.CasualLeave ?? 0}</td>
                            <td>{leaveData?.OfficialLeave ?? 0}</td>
                            <td>{leaveData?.SickLeave ?? 0}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="user-report-no-data">
                      Select an employee to view leave data.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default UserReport;